import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { aboutStats } from "@/mocks/about";

export default function AboutStats() {
  return (
    <section className="bg-primary-950 py-20 md:py-24">
      <div className="shell">
        <Reveal>
          <SectionHeading
            eyebrow="Rakamlarla d.mar"
            title="Yılların birikimi, güvenilir hizmet"
          />
        </Reveal>

        <div className="mt-14 grid grid-cols-2 gap-4 lg:grid-cols-4">
          {aboutStats.map((stat, index) => (
            <Reveal key={stat.label} delay={index * 80}>
              <div className="relative overflow-hidden rounded-xl border border-background-50/15 bg-background-50/5 px-6 py-8 text-center">
                <span
                  className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent-400/60 to-transparent"
                  aria-hidden="true"
                />
                <div className="font-heading text-3xl font-medium text-accent-400 md:text-4xl">
                  {stat.value}
                </div>
                <p className="mt-2 text-sm text-background-200/85">{stat.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}